import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { OnDemandDriversService } from "../../../../on-demand-drivers/on-demand-drivers.service";
import { OnDemandDriverModel } from "../../../../on-demand-drivers/on-demand-drivers.model";
import * as moment from "moment";
import { T2LoadingService } from "../../../../../trip2-theme/components/t2-loading/t2-loading.service";
import { Subscription } from "rxjs/Subscription";
import { SweetAlertHelper } from "../../../../../core/helpers/sweet-alert-helper.service";
import { BackgroundCheckService } from 'app/services/background-check.service';
import { finalize } from 'rxjs/operators';
import { DriverBackgroundCheckApiService } from '../../../../../utils/driver-background-check/driver-background-check-api.service';

@Component({
  selector: 'app-background-checks-form',
  templateUrl: './background-checks-form.component.html',
  styleUrls: ['./background-checks-form.component.scss']
})
export class BackgroundChecksFormComponent implements OnInit, OnChanges, OnDestroy {

  addedonFormated: string;
  title: string;
  public showLoading = false;
  data: OnDemandDriverModel = new OnDemandDriverModel();
  @Output() onCancel = new EventEmitter<boolean>();
  @Input() userProfileId: number;
  @Input() renewals: boolean;
  reportRenewals: any;

  private subscriptions: Subscription[] = [];

  constructor(
    protected service: OnDemandDriversService,
    private _loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
    private backgroundCheckService: BackgroundCheckService,
    private driverBackgroundCheckApiService: DriverBackgroundCheckApiService
  ) { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['userProfileId'] && this.userProfileId) {
      this.getDriverById();
      this.getReportRenewals();
    }
  }

  getReportRenewals() {
    this.subscriptions.push(
      this.backgroundCheckService
        .getBackgroundCheckRenewals(this.userProfileId)
        .subscribe({
          next: (data) => {
            this.reportRenewals = data;
          },
          error: (error) => {
            this.sweetAlertHelper.createCustomAlert({
              text: error,
              type: "error",
            });
          },
        })
    );
  }

  getDriverById() {
    if (this.userProfileId) {
      this._loading.show();
      this.subscriptions.push(
        this.service
          .getDriverDetails(this.userProfileId)
          .pipe(finalize(() => this._loading.hiden()))
          .subscribe({
            next: (data) => {;
              if (data) {
                this.loadData(data);
              } else {
                data = null;
              }
            },
            error: (error) => {
              this.sweetAlertHelper.createCustomAlert(error);
            },
          }),
      );
    }
  }


  loadData(data) {
    this.data = data;
    if (data.addedon) {
      this.formatedDate(data.addedon);
    }
    this.title = `${data.firstname} ${data.lastname}`;
  }

  formatedDate(addedon: Date) {
    const date = new Date(addedon);
    this.addedonFormated = moment(date).format('MM-DD-YYYY');
  }

  public runBackgroundCheck() {
    this._loading.show('Loading Background Check');
    this.showLoading = true;
    this.subscriptions.push(
      this.driverBackgroundCheckApiService
        .runCheck(this.userProfileId)
        .pipe(finalize(() => {
          this.showLoading = false;
          this._loading.hiden();
        }))
        .subscribe({
          next: () => {
            this.sweetAlertHelper.createCustomAlert({
              text: 'Successful',
              type: 'success'
            });
            this.onCancel.emit();
          },
          error: (error) => {
            this.sweetAlertHelper.captureException(error);
          },
        })
    );
  }

  classColor(status: string): string {
    return `checkr-${status}`;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/administration/fleet/background-checks/background-checks-form/background-checks-form.component.ts